module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "CHAPTER 1"
    }
  }, [_c('p', {
    staticClass: "h2",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rch1"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("[1]")])])])]), _vm._v(" "), _c('p', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rch1"
    }
  }, [_vm._v("WHAT IS FAST FAITH?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_vm._v("Ours is a hurried age in which speed is deified and waiting is demonized.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ours is a cluttered age in which noise is the norm and images constantly clamor for our attention.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And in our hurried, cluttered age, "), _c('i', [_vm._v("faster")]), _vm._v(" has become synonymous with "), _c('i', [_vm._v("better")]), _vm._v(", and "), _c('i', [_vm._v("experience")]), _vm._v(" has become a substitute for "), _c('i', [_vm._v("relationship")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The problem, however, is that faster experiences do not produce better relationships with people or with God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Relationship with God is best fed by a steady practice of attentiveness to God (as opposed to a diet of relative neglect, interrupted occasionally by quick spikes of engagement and intense surges of experience), which may help explain some of the spiritual dissatisfaction and burnout puzzling countless sincere souls in our day. We mistake the spikes and surges for spiritual strength and are left wondering why our faith at times still feels uneven and lonely.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Changing such age-old patterns requires new thinking, and that, at first, can seem strenuous. We are so attached to—and consequently so protective of—our fast, experiential, adrenaline-addicted culture that we confidently call physical spikes "), _c('i', [_vm._v("energy")]), _vm._v(" and spiritual spikes "), _c('i', [_vm._v("inspiration")]), _vm._v(". And when the physical and spiritual align—when we feel something tangible in our senses while thinking something spiritual in our minds—we call it "), _c('i', [_vm._v("intimacy with God")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The potential combinations of surges and spikes are almost "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("endless in an age where many, but certainly not all, Jesus-followers suffer an embarrassment of spiritual riches. Inspirational quotes are at our fingertips. Moving devotionals remind us that God’s mercies are new multiple times every morning. Books abound. The best of the best sermons, interviews, and teachings are instantly accessible. These ever-expanding options are then supercharged by prayerfully and carefully crafted weekly services and truly breathtaking seasonal conferences and conventions.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, God did not architect us to live—physically or spiritually—on adrenaline surges, however excellent their choreography may be. By divine design, we flourish with a connectivity that is more even and steady: one that accompanies each breath and affects each step. Faith is a glorious opportunity to live "), _c('i', [_vm._v("in Him")]), _vm._v("—with or without the experience of feelings—through willful, moment-by-moment attentiveness to Jesus, Whose presence neither surges nor wanes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fast Faith, in contrast, lives surge to surge, ever alert to formulas and combinations that help the feelings linger longer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fast Faith interprets the sensory crashes in between surges not as waning adrenaline or normalization but rather as a lack of devotion or—even more erroneously—as the absence of God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fast Faith is a restless spirituality that often craves what is "), _c('i', [_vm._v("new")]), _vm._v(" and what is "), _c('i', [_vm._v("next")]), _vm._v(", in the recycled hope that the latest “it” can satisfy an ache that can only be described as timeless.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And sadly"), _c('i', [_vm._v(",")]), _vm._v(" Fast Faith is also one of the reasons a generation is departing from Christianity to explore other religions that promise inner peace. To date, I have never heard anyone excuse him- or herself from the table because there were not enough excellent or exciting offerings to choose from, but because, after eating, he or she still felt hungry. Their complaint is about sustainability: “It was great. But it just didn’t last.” So he or she keeps wandering in search of something that will endure, in search of a feeling that can "), _c('i', [_vm._v("remain")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("In truth, only God "), _c('i', [_vm._v("remains")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And God is not a feeling.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("GUIDED RESPONSE")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_vm._v("Before You Begin")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Each of the fifty-two experiences in "), _c('i', [_vm._v("The Sacred Slow")]), _vm._v(" contains two components—a reading and a guided response. Every guided response offers two options for engagement through a thought focus or an exercise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The thought foci are questions or statements for reflection, personal journaling, or conversation with friends. The exercises are strategic sets of action steps designed to mentor you in the holy habit of intentionality toward your spiritual formation. Some will feel fun and natural, and others may feel clumsy and uncomfortable. For this context, the latter are needed as much as the former.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("How long it will take to experience "), _c('i', [_vm._v("The Sacred Slow")]), _vm._v(" depends on what is best for you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though diverse in style and length, the readings are relatively short and can be scanned in a day. A prayerful consideration of each chapter’s reading and its thought focus might take one or two weeks. To meaningfully engage in the readings and the exercises, I recommend twelve weeks—which is why the book is formatted in twelve movements. However, many have taken an even slower pace and sat with one chapter a week for a year.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the beginning of each new movement, consider your schedule and invest for the duration of that movement in "), _c('i', [_vm._v("either")]), _vm._v(" the thought focus or the exercise. You can always return and do the other level of response at another time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most often, both options will flow directly from the chapter reading. However, in the first two movements, the readings will "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("focus on the story behind the book and the guided response options will focus on the story of your life.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For many, the first nine exercises are the most intense as far as requiring the cooperation of your head, heart, and hands. As a mentor, I would rather you choose the less intense level of response (the thought focus) if you think that the intensity of these first exercises might cause you to abandon "), _c('i', [_vm._v("The Sacred Slow")]), _vm._v(" prematurely.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Remember that consistency can still be creative. Maybe you will thrive reading "), _c('i', [_vm._v("The Sacred Slow")]), _vm._v(" at the same time every morning. Maybe you are wired more for an extended block of time to focus on the journey once a week. Either way, shape your experience to complement how God has designed you.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_vm._v("Thought Focus:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If your history were to be made into a movie, what sets would the director design as the backdrop for the most formative moments of your life?")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_vm._v("Exercise:")]), _vm._v(" "), _c('p', {
    staticClass: "nlist-1"
  }, [_c('span', {
    staticClass: "hide1"
  }), _vm._v("1."), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide1"
  }), _vm._v("Generate a list of three or four trusted souls who (a) know you very well and (b) are emotionally safe. These are individuals who love you enough to be honest and are healthy enough not to abuse you with that honesty.")])]), _vm._v(" "), _c('p', {
    staticClass: "nlist-1"
  }, [_c('span', {
    staticClass: "hide1"
  }), _vm._v("2."), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide1"
  }), _vm._v("Generate a list of three or four trusted souls whom you spiritually respect for the depth of their love for Jesus.")])]), _vm._v(" "), _c('p', {
    staticClass: "nlist-1"
  }, [_c('span', {
    staticClass: "hide1"
  }), _vm._v("3."), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide1"
  }), _vm._v("Contact each person listed with some version of the following: "), _c('i', [_vm._v("I am working my way through a book with exercises that sometimes require input from respected friends. I’d like to ask if you’d pray for me whenever I come to mind and also if you would be willing to help me out by responding to a few questions along the way. I’d be honored if you can say yes, but there’s no pressure and no problem if you need to say no.")])])]), _vm._v(" "), _c('p', {
    staticClass: "nlist-1"
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide1"
  }), _vm._v("Begin creating your Life Scroll. The first five exercises of "), _c('i', [_vm._v("The Sacred Slow")]), _vm._v(" focus on the development of a timeline that will evolve into an insightful spiritual tool. As the rings of a tree trunk tell some of its story, your Life Scroll will enable you to see your life in layers and then interact with those layers anew in a way that is often healing.")])])]), _vm._v(" "), _c('p', {
    staticClass: "blist1"
  }, [_c('span', {
    staticClass: "hide1"
  }), _vm._v("•"), _c('span', {
    staticClass: "space_01"
  }, [_c('span', {
    staticClass: "hide1"
  }), _vm._v("Unfold your Life Scroll from the Toolbox in the back of the book. Make a timeline at the bottom edge of the page by labeling each tick with a year, starting with your birth and ending with next year.")])]), _vm._v(" "), _c('p', {
    staticClass: "blist1"
  }, [_c('span', {
    staticClass: "hide1"
  }), _vm._v("•"), _c('span', {
    staticClass: "space_01"
  }, [_c('span', {
    staticClass: "hide1"
  }), _vm._v("Above the corresponding year, populate row 1 with information that the government and/or insurance companies have recorded, such as the date and city of your birth, significant dates in your family’s history, out-of-country travel, dates and names of schools attended, when you received your driver’s license, moves, jobs, new business endeavors, major purchases, illnesses, accidents, adoptions, etc.")])]), _vm._v(" "), _c('p', {
    staticClass: "blist1"
  }, [_c('span', {
    staticClass: "hide1"
  }), _vm._v("•"), _c('span', {
    staticClass: "space_01"
  }, [_c('span', {
    staticClass: "hide1"
  }), _vm._v("For example, the first timeline tick at the base of my Life Scroll is labeled 1965. Above it, in the first row, I have written: "), _c('i', [_vm._v("born in Las Vegas, NV")]), _vm._v(". Above 1990: "), _c('i', [_vm._v("married Barry Jay Chole")]), _vm._v(". Above 1999: "), _c('i', [_vm._v("son diagnosed with autism")]), _vm._v(". Above 2001: "), _c('i', [_vm._v("Daddy died")]), _vm._v(". Above 2010: "), _c('i', [_vm._v("purchased prayer retreat home")]), _vm._v(". Above 2013: "), _c('i', [_vm._v("diagnosed with breast cancer.")]), _vm._v(" Above 2016: "), _c('i', [_vm._v("took daughter to Australia")]), _vm._v(". Above 2017: "), _c('i', [_vm._v("published")]), _vm._v(" The Sacred Slow.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("With exercises like this, it is easy to spend the whole time mentally talking to yourself. Attempt to work through each part of this exercise conscious of God and in prayerful conversation with Him. He foresaw and was present for every single moment you are describing.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb49dd2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780718094966_Chapter_1.vue
// module id = 84
// module chunks = 0